import { createSlice } from '@reduxjs/toolkit'

export const buddiesSlice = createSlice({
    name: 'buddies',
    initialState: {
        items: null,

    },
    reducers: {
        setBuddies: (state, action) => {
            const items = action.payload.items
            state.items = items
        },
        follow: (state, action) => {
            if (action.payload.unfollow)
                state.items = state.items?.filter((value) => value.buddy !== action.payload.buddy.buddy)
            else
                if (state.items == null) state.items = [action.payload.buddy.buddy]
                else
                    state.items.push(action.payload.buddy)
        }

    },

});
export const { setBuddies, follow } = buddiesSlice.actions
export default buddiesSlice.reducer;